<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CatalogueLive code="dec_jud_ouinon" v-model="declarationsJudiciaires.decisionType1" :live="liveDeclaration(8902)"></CatalogueLive>
      <template v-if="estOui(declarationsJudiciaires.decisionType1)">
        <AntecedentsJudiciaires
          :antecedents="antecedents('DECIS')"
          :sasId="sas.id"
          codeInfraction="DECIS"
          :valids="validsType1"
          ref="dataIterator_1"
        ></AntecedentsJudiciaires>
      </template>

      <v-divider class="my-3"></v-divider>

      <CatalogueLive code="dec_p5_ouinon" v-model="declarationsJudiciaires.decisionType2" :live="liveDeclaration(8903)"></CatalogueLive>
      <template v-if="estOui(declarationsJudiciaires.decisionType2)">
        <AntecedentsJudiciaires
          :antecedents="antecedents('POUR 5A')"
          :sasId="sas.id"
          codeInfraction="POUR 5A"
          :valids="validsType2"
          ref="dataIterator_2"
        ></AntecedentsJudiciaires>
      </template>

      <v-divider class="my-3"></v-divider>

      <CatalogueLive code="dec_rp_ouinon" v-model="declarationsJudiciaires.decisionType3" :live="liveDeclaration(8904)"></CatalogueLive>
      <template v-if="estOui(declarationsJudiciaires.decisionType3)">
        <AntecedentsJudiciaires
          :antecedents="antecedents('POUR RP')"
          :sasId="sas.id"
          codeInfraction="POUR RP"
          :valids="validsType3"
          ref="dataIterator_3"
        ></AntecedentsJudiciaires>
      </template>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelpers from "../ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import AntecedentsJudiciaires from "@/components/form_parts/AntecedentsJudiciaires"
import { deleteAllOfType } from "@/plugins/services/antecedentsJudiciaires"
export default {
  mixins: [CataloguesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object, required: true }
  },
  data() {
    return {
      validsType1: [],
      validsType2: [],
      validsType3: []
    }
  },
  components: { AntecedentsJudiciaires },
  watch: {
    "declarationsJudiciaires.decisionType1": function (newValue) {
      this.deleteOfType(newValue, "DECIS")
      this.$emit("validation-changed", this.isValid)
    },
    "declarationsJudiciaires.decisionType2": function (newValue) {
      this.deleteOfType(newValue, "POUR 5A")
      this.$emit("validation-changed", this.isValid)
    },
    "declarationsJudiciaires.decisionType3": function (newValue) {
      this.deleteOfType(newValue, "POUR RP")
      this.$emit("validation-changed", this.isValid)
    },
    validsType1() {
      this.$emit("validation-changed", this.isValid)
    },
    validsType2() {
      this.$emit("validation-changed", this.isValid)
    },
    validsType3() {
      this.$emit("validation-changed", this.isValid)
    }
  },
  computed: {
    declarationsJudiciaires() {
      return this.sas.declarationsJudiciaires
    },
    isValid() {
      return this.valid && this.validsType1.every((x) => x) && this.validsType2.every((x) => x) && this.validsType3.every((x) => x)
    }
  },

  methods: {
    liveDeclaration(cle) {
      return { endpoint: "sas-declarations-judiciaires", cle: cle, fileId: this.declarationsJudiciaires.id }
    },
    antecedents(codeInfraction) {
      let found = this.sas.antecedentsJudiciaires.find((a) => a.codeInfraction == codeInfraction)
      if (found) {
        return found.antecedents || []
      }
      return []
    },
    deleteOfType(value, codeInfraction) {
      if (this.estNon(value)) {
        deleteAllOfType(this.sas.id, codeInfraction)
        let antecedents = this.antecedents(codeInfraction)
        antecedents.splice(0, antecedents.length)
        this.resetValidsType(codeInfraction)
      }
    },
    resetValidsType(codeInfraction) {
        if (codeInfraction == "DECIS") {
          this.validsType1 = []
        }
        else if (codeInfraction == "POUR 5A") {
          this.validsType2 = []
        }
        else if (codeInfraction == "POUR RP") {
          this.validsType3 = []
        }
    }
  }
}
</script>

<style>
</style>